import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';

import { BaseService } from './base.service';
import { DataType } from '../models/data-type.model';
import { ParameterType } from '../models/parameter-type.enum';
import { ParameterRange } from '../models/parameter-range.model';
import { ActivityLog } from '../models/activity-log.model';
import { Note } from '../models/note.model';
import { MetaDataMapping } from '../models/meta-data.model';

@Injectable()
export class DataService extends BaseService {
  private maps: {
    parameterType: {}
  };

  constructor(protected http: Http) {
    super(http);
    this.maps = {
      parameterType: null
    };
    this.initialize();
  }

  async initialize() {
    this.maps.parameterType = await this.get('map/parameterType');
  }

  async getItem(dataType: string, id: string): Promise<any> {
    return this.get('data/' + dataType + '/' + id);
  }

  async getActivityLog(dataType: string, id: string): Promise<ActivityLog[]> {
    return this.get('activityLog/' + dataType + '/' + id);
  }

  async getNote(dataType: string, id: string): Promise<Note> {
    return this.get('notes/' + dataType + '/' + id);
  }

  async updateNotes(dataType: string, id: string, notes: string): Promise<any> {
    return this.post('notes/' + dataType + '/' + id, {notes: notes});
  }

  async getSignedUrl(dataType: string, guid: string): Promise<string> {
    return this.get('data/signedUrl/' + encodeURIComponent(dataType) + '/' + encodeURIComponent(guid));
  }

  async getDataTypes(): Promise<DataType[]> {
    return this.get('dataTypes');
  }

  async getDataTypeByAbbr(abbr: string): Promise<DataType> {
    return this.get('dataTypes/' + abbr);
  }

  // DEPRECATED
  // async createArchive(dataItems: Array<any>, isFromApprovalPage?: boolean): Promise<string> {
  //   return this.post('createArchive', {dataItems: dataItems, isFromApprovalPage: isFromApprovalPage});
  // }

  async createSpreadsheet(dataItems: Array<any>, emailDownloadLink?: boolean): Promise<string> {
    return this.post('createSpreadsheet', {dataItems: dataItems, emailDownloadLink: emailDownloadLink});
  }

  public getParameterType(spreadsheetId: string, columnId: string): ParameterType {
    try {
      return this.maps.parameterType[spreadsheetId][columnId] || ParameterType.text;
    }
    catch (e) {
      return ParameterType.text;
    }
  }

  public async getParameterRange(spreadsheetId: string, columnId: string): Promise<ParameterRange> {
    return this.get('parameterRange/' + spreadsheetId + '/' + columnId);
  }

  public async getFamilyMembers(familyId: string) {
    return this.get('familyMembers/' + familyId);
  }

  public async getFamily(familyId: string) {
    return this.get('family/' + familyId);
  }

  public async getDataByPatientId(patientId: string) {
    return this.get('patient/' + patientId + '/data');
  }

  public async getDicomData(patientId: string) {
    return this.get('patient/' + patientId + '/dicom');
  }

  public async getAllMetadata(datatypeAbbr: string, dataId: any): Promise<Array<any>> {
    return this.get('metadata/' + datatypeAbbr + '/' + dataId);
  }

  public async getSingleMetadata(datatypeAbbr: string, dataId: any, sheet: string, column: string): Promise<Array<any>> {
    return this.get('metadata/' + datatypeAbbr + '/' + dataId + '/' + sheet + '/' + column);
  }

  public async deleteImage(imageId: number): Promise<any> {
    return this.delete('image/' + imageId);
  }

  public async deletePatient(patientId: string): Promise<any> {
    return this.delete('patient/' + patientId);
  }

  public async getMapping(spreadsheetId: string, columnId: string): Promise<MetaDataMapping> {
    return this.get('metadata/map/' + spreadsheetId + '/' + columnId);
  }

  async getAllDataDetails(dataType: string, id: string): Promise<any> {
    return this.get('data/details/' + dataType + '/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts